import React, { useEffect, useState } from "react";
import ThreeDots from "../../images/threeDots.svg";
import dateFormat from "dateformat";
import CallImg from "../../images/call.svg";
import {
  correctTimeDate,
  CurrencySymbol,
  handleOffers,
  validateTicket,
} from "../../utils/util";
import TicketInternal from "../../pages/profile/components/TicketInternal";
import Threedot from "../alert/Threedot";
import { checkRequestStatus } from "../../actions/orderHistory";
import RequestCheckAlert from "../alert/RequestCheckAlert";
import ForwardArrow from '../../images/ForwardArrow.svg';
import DownArrow from '../../images/arrow_down.svg';
function OrderCard(props) {
  const [orderId, setOrderId] = useState("");
const [RequestStatus,setRequestStatus] = useState('');
const [earlyCHeckinStatus,setearlyCHeckinStatus] = useState(false);
const [roomChangeReq ,setRoomChangeReq] = useState(false);
const [extendStayReq,setExtendStayReq] = useState(false);
const [CardName,setCardName] = useState('');
const [amount,setAmount] = useState("")
const [gstrate,SetGstRate] = useState("");
const [gstamount,SetGstAmount] = useState("")

  const [showMore, setShowMore] = useState(false);
  const [isCartVisible, setIsCartVisible] = useState(false);
  const showCart = (param) => {
    setIsCartVisible((prevState) => !prevState);
    // console.log(param);
    if (orderId != param) {
      setOrderId(param);
    } else {
      setOrderId("");
    }
  };
  const appUserId = localStorage.getItem("appUserId");
 const reservationId = localStorage.getItem("reservationId");
//  console.log("guestDetails?.=================",reservationId)
//  console.log("appUserId===================",appUserId)

const getRequestStatus = async () => {
  try {
    const res = await checkRequestStatus(reservationId, appUserId);
    console.log("Full API response:", res);

    if (res && res.success) {
      console.log("API response data588:", res);
      setRequestStatus(res.data);
      if(res.data.earlyCHeckinEdit === false){
        // console.log("open modal")
        setearlyCHeckinStatus(true);
      }else{
        setearlyCHeckinStatus(false);
        console.log("close modal")

      }
      if(res.data.roomChangeEdit === false){
        setRoomChangeReq(true);
      }else{
        setRoomChangeReq(false);
      }

      if(res.data.extendStayEdit === false){
        setExtendStayReq(true);
        console.log("modaltrue","true")
      }else{
        setExtendStayReq(false);
        console.log("false")

      }
      return res.data; 
    } else {
      // console.log("API response does not indicate success:", res);
      return null; 
    }
  } catch (e) {
    console.log(e);
    return null; 
  }
};

useEffect(() => {
  if (props?.historyData?.cart) {
    const totalAmount = props.historyData.cart
      .filter((item) => item.isFullfilled === 1)
      .reduce((total, item) => {
        const finalPrice = handleOffers(item.price, item.discount) * item.quantity;
        return total + finalPrice;
      }, 0)
      .toFixed(2);
    
    setAmount(parseFloat(totalAmount));
    
    const gstrate = props.historyData.cart[0]?.gst;
    SetGstRate(gstrate); 
    
    const gstAmount = gstrate ? (totalAmount * gstrate) / 100 : 0;
    SetGstAmount(gstAmount);
  }
}, [props.historyData.cart]);

function checkFunctionCard(namecard) {

  setCardName(namecard);
}
  const handleSeeMore = ()=>{
     setShowMore(!showMore)
  }

   // currency setup
  const currencySymbol = CurrencySymbol();

  return (
    <div className="order-history">
      {/* <div className='card mb-2'>{props.historyData.redirect}</div> */}

      {props.historyData.redirect === "inRoomDining" && (
        <div className="card mb-2 relative">
          <div className="absolute top-3 right-2  item-date"style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading flex items-center pt-[20px]">
            Inroom Dining 
          </div>
         <div className="card-heading">( {props.historyData?.restaurant_name} )</div>
          <div className="item-heading mt-1">
            {props.historyData.cart[0].itemName}
            {props.historyData.cart.length !== 1 && (
              <span> + {props.historyData.cart.length - 1} item </span>
            )}
          </div>
          {/* <div className="item-date mt-1">
            {correctTimeDate(
              props.historyData.bookingDate,
              "dd mmm yy 'at' h:MMtt"
            )}
          </div> */}
          
          {props.historyData.status == "Requested" && (
            <div className="item-requested mt-3">
              <span>Requested.</span>
              {/* You will be notify once order is confirmed */}
            </div>
          )}

          {props.historyData.status == "Processed" && (
            <div className="item-process mt-3 whitespace-nowrap">
              <span>Processing.</span>
              { props.historyData.cart.some((item)=>item?.isFullfilled == 0) ? (
                 <span className="ml-1"> Some items are not available </span> 
              ) : <span className="ml-1"> your order will be delivered soon. </span> }
            </div>
          )}

          {props.historyData.status == "Completed" && (
            <div className="item-accepted mt-3">
              <span>Completed.</span>
            </div>
          )}

          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
          <div
            onClick={() => showCart(props.historyData.id)}
            className="absolute top-7 right-3 p-2 cursor-pointer"
          >
            <img className="w-[20px] h-[20px]"  src={isCartVisible ? DownArrow : ForwardArrow} alt="" />
          </div>
          {orderId == props.historyData.id && (
            <div className="mt-2">
              {props.historyData.cart.map((item, i) => (
                <div
                  key={i}
                  className="flex w-full justify-between mb-1 food-item text-white  " 
                >
                    <div className={item?.isFullfilled  ? "flex flex-col " : "line-through flex flex-col"}> 
                      <div className="truncate max-w-[160px] w-full">{item.itemName} ({item.quantity}) </div>
                      {item?.discount && 
                        <div
                                className="line-through text-[10px]"
                                style={{ color: "#a69e9e" }}
                              >
                                {currencySymbol}{item?.price * item.quantity}
                        </div>
                      }
                  </div>
                  <div className={!item?.isFullfilled && "line-through"}>
                    {item?.discount ? (
                      <div className="flex   items-center h-[100%]  gap-2">
                        <div className=" ">
                          {currencySymbol}
                          {(
                            handleOffers(
                              item?.price,
                              parseInt(item?.discount)
                            ) * item.quantity
                          ).toFixed(2)}
                        </div>
                      </div>
                    ) : (
                      <div>
                        {" "}
                        <span>{currencySymbol}</span>{" "}
                        <span>{item?.price * item.quantity}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <div className="mt-3 w-full h-[0.5px] bg-gray-100"></div>
              { gstrate !== null ? (
              <>
                <div className="w-full flex justify-between mt-2 text-white">    
                <div className="item-heading text-white w-[80%] flex justify-end"><div className="w-[30%]">Item Total</div></div>
                <div className="text-sm">
                {currencySymbol}{parseFloat(amount).toFixed(2)}
                </div>
                </div>
                <div className="w-full flex justify-between mt-2 text-white">
                <div className="item-heading text-white w-[80%] flex justify-end"><div className="w-[30%]">GST</div></div>
                <div className="text-sm">
                {currencySymbol}{parseFloat(gstamount).toFixed(2)}
                </div>
                </div>
                <div className="flex flex-row justify-end h-full">
                <div className="mt-3 w-[225px] h-[0.5px] bg-gray-100"></div>
                </div>
                <div className="w-full flex justify-between mt-2 text-white">
                <div className="item-heading text-white w-[80%] flex justify-end"><div className="w-[30%]">Grand Total</div></div>
                <div className="text-sm">
                {currencySymbol}{parseFloat(amount + gstamount).toFixed(2)}
                </div>
                </div>
              </>
              ) : ''}
              {gstrate == null ? (
              <>
              <div className="w-full flex justify-between mt-2 text-white">
              <div className="item-heading text-white w-[80%] flex justify-end"><div className="w-[60%]">Grand Total (Inclusive of GST)</div></div>
              <div className="text-sm">
              {currencySymbol}{parseFloat(amount + gstamount).toFixed(2)}
              </div>
              </div>
              </>
              ) : ''}
            </div>
          )}
        </div>
      )}

      {props.historyData.redirect === "tableBooking" && (
        <div className="card mb-2 relative">
          <div className="absolute top-2 right-2 item-date"style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]">
            Table Dining 
          </div>
          <div className="card-heading">({props.historyData?.restaurant_name})</div>
          <div className="item-heading mt-1">
            {props.historyData.restaurantTable}
          </div>
          <div className="item-date mt-1">
            {dateFormat(
              props.historyData.bookingDate,
              "dd mmm yy 'at' h:MM TT"
            )}
          </div>
          <div className="item-date mt-1">
            Occupancy: {props.historyData.noOfGuests}
          </div>
          {/* Requested Accepted Cancelled */}
          {props.historyData.status == "Requested" && (
            <>
              <div className="item-requested mt-3">
                <span>Requested.</span>
                {/* You will be notify once order is confirmed{" "} */}
              </div>
              <div className="absolute top-7 right-0 p-2 cursor-pointer" >
              <Threedot  onDataUpdate={(id)=>props.onDataUpdate(id)} name='Table_Dining' data={props.historyData} checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("Table_Dining") } />
            </div>
           </>
          )}
          {props.historyData.status == "Accepted" && (
            <div className="item-accepted mt-3">
              <span>Accepted.</span>
            </div>
          )}
          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
        </div>
      )}

      {props.historyData.redirect === "spa" && (
        <div className="card mb-2 relative">
          <div className="absolute top-2 right-2 item-date"style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]">
            Spa 
          </div>
          <div className="card-heading">({props.historyData?.spa_name})</div>
          <div className="item-heading mt-1">
            {props.historyData.spaServiceName}
          </div>
          <div className="item-date mt-1">
            Booked for:  <span className="ml-1">  {dateFormat(
              props.historyData.bookingDate,
              "dd mmm yy 'at' h:MM TT"
            )}</span>

          </div>
          <div className="item-date mt-1">
            Occupancy: {props.historyData.noOfPeople}
          </div>
          <div className="item-date mt-1">
            Price:{currencySymbol}{((props.historyData.price * props.historyData.noOfPeople)+((props.historyData.price * props.historyData.gst / 100) * props.historyData.noOfPeople)).toFixed(2)}{props.historyData.gst !== null ? ` (Inclusive of GST)` : ''}
          </div>
          {/* Requested  Accepted  Cancelled */}
          {props.historyData.status == "Requested" && (
            <>
              <div className="item-requested mt-3">
                <span>Requested.</span>
                {/* You will be notify once order is confirmed{" "} */}
              </div>
              <div className="absolute top-7 right-0 p-2 cursor-pointer" >
                <Threedot onDataUpdate={(id)=>props.onDataUpdate(id)}  name='spa' data={props.historyData} checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("spa") } />
              </div>
            </>
          )}
          {props.historyData.status == "Accepted" && (
            <div className="item-accepted mt-3">
              <span>Accepted.</span>
            </div>
          )}
          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
        </div>
      )}
      {props.historyData.redirect === "wakeUp" && (
        <div className="card mb-2 relative">
             <div className="absolute top-2 right-2 item-date"style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]">Wake up</div>
          <div className="item-heading mt-1">{props.historyData.method}</div>
          <div className="item-date mt-1">
            {/* Wake up at: */}
            <span className="">{dateFormat(
              props.historyData.wakeup_time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>

          {props.historyData.status == "Requested" && (
            <>
            <div className="item-requested mt-3">
              <span>Requested.</span>
              {/* You will be notify once order is confirmed{" "} */}
            </div>
             <div className="absolute top-7 right-0 p-2 cursor-pointer" >
             <Threedot onDataUpdate={(id)=>props.onDataUpdate(id)} name='wakeUp' data={props.historyData} checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("wakeUp") } />
           </div>
           </>
          )}
          {props.historyData.status == "Rejected" && (
            <div className="item-cancelled mt-3">
              <span>Rejected</span>
              {/* You will be notify once order is confirmed{" "} */}
            </div>
          )}
          {props.historyData.status == "Accepted" && (
            <div className="item-accepted mt-3">
              <span>Accepted.</span>
            </div>
          )}
          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
        </div>
      )}
      {/* Requested Accepted Rejected Cancelled */}
      {props.historyData.redirect === "roomChange" && (
        <div className="card mb-2 relative">
          <div className="absolute top-3 right-2  item-date"style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]"></div>
          <div className="item-heading pb-[20px] mt-1">Room Change</div>

          {props.historyData.status == "Requested" && (
            <>
            <div className="item-requested mt-3">
              <span>Requested.</span>
              {/* You will be notify once order is confirmed{" "} */}
            </div>
             <div className="absolute top-7 right-0 p-2 cursor-pointer" >
             <Threedot name='roomChange' data={props.historyData} checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("roomChange") }/>
              </div>
              </>
          )}

          {props.historyData.status == "Accepted" && (
            <div className="item-accepted mt-3">
              <span>Accepted.</span>
            </div>
          )}

          {props.historyData.status == "Rejected" && (
            <div className="item-cancelled mt-3">
              <span>Rejected.</span>
            </div>
          )}

          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
            {/* {props.historyData.status == "Requested" && (
            <div className="absolute top-1 right-0 p-2 cursor-pointer" >
            <Threedot/>
             </div>
            )} */}
        </div>
      )}

      {props.historyData.redirect === "extendStay" && (
        <div className="card mb-2 relative">
          <div className="absolute top-3 right-2  item-date"style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]">Extend Stay</div>
          <div className="item-heading mt-1">
          Booking Extented to  {dateFormat(props.historyData.toDate,"dd mmm yy")}
          </div>

          {props.historyData.status == "Requested" && (
            <>
            <div className="item-requested mt-3">
              <span>Requested.</span>
              {/* You will be notify once order is confirmed{" "} */}
            </div>
             <div className="absolute top-7 right-0 p-2 cursor-pointer" >
             <Threedot name='extendStay' data={props.historyData}  checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("extendStay") } />
         </div>
         </>
          )}

          {props.historyData.status == "Accepted" && (
            <div className="item-accepted mt-3">
              <span>Accepted.</span>
            </div>
          )}

          {props.historyData.status == "Rejected" && (
            <div className="item-cancelled mt-3">
              <span>Rejected.</span>
            </div>
          )}

          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
          {/* three dots for extend stay */}
        
      </div>
      )}

      {props.historyData.redirect === "event" && (
        // <div className="card mb-2 relative">
        //   <div className="card-heading">Event</div>
        //   <div className="item-heading mt-1 text-white">
        //     {props.historyData.eventName}
        //   </div>
        //   <div className="item-date mt-1 ">
        //     Occupancy : {props.historyData.bookedFor}
        //   </div>
        //   <div className="text-white">
        //     {props.historyData?.offer ? (
        //       <div className="flex item-center text-white gap-2">
        //         <div className="line-through" style={{ color: "#a69e9e" }}>
        //           ₹{props.historyData?.bookedFor * props.historyData?.price}
        //         </div>
        //         <div>
        //           ₹
        //           {props.historyData?.bookedFor *
        //             handleOffers(
        //               props.historyData?.price,
        //               parseInt(props.historyData?.offer)
        //             )}
        //         </div>
        //       </div>
        //     ) : (
        //       <div>
        //         {" "}
        //         <span>₹</span> <span>{props.historyData?.price}</span>
        //       </div>
        //     )}
        //   </div>
        //   {props.historyData.status == "Booked" && (
        //     <div className="item-requested mt-3">
        //       <span>Booked.</span>
        //     </div>
        //   )}
        //   {props.historyData.status == "Cancelled" && (
        //     <div className="item-cancelled mt-3">
        //       <span>Cancelled.</span>
        //     </div>
        //   )}
        // </div>
        <TicketInternal
          data={props.historyData}
          active={validateTicket(props.historyData?.bookedForDate)}
        />
      )}

      {props.historyData.redirect === "earlyCheckin" && (
        <div className="card mb-2 relative">
          <div className="absolute top-3 right-2  item-date"style={{fontSize:"11px"}}>
            Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]">Early Check-in </div>
          <div className="item-heading mt-2">
            {props.historyData.beforeOrAfter}<span> Hr before Check-in time</span>
          </div>
         {props.historyData?.adminComment ?  <div className="card-heading mt-2">Comment</div> : null}
          <div className="flex items-end flex-nowrap break-all text-xs"> <div className={!showMore && props.historyData?.adminComment.length >= 42 ? "mt-2 admin-comment-short" : "mt-2"}>{props.historyData?.adminComment}</div>
          {!showMore  && props.historyData?.adminComment.length >= 42 && <span onClick={()=>handleSeeMore()} className="text-[#7AC8FF] cursor-pointer whitespace-nowrap">See more</span>}</div>
            {/* {"Comment Comment Comment Comment Com"?.length }
            <span>Comment Comment Comment Comment Comme</span> */}
           {showMore  && <span onClick={()=>handleSeeMore()} className="text-[#7AC8FF] cursor-pointer text-xs">See Less</span>} 
          {props.historyData.status == "Requested" && (
            <div className="item-requested mt-3">
              <span>Requested.</span>
              {/* You will be notify once order is confirmed{" "} */}
              {/* <div className="absolute top-7 right-0 p-2 cursor-pointer" >
              <Threedot name = {"earlyCheckin"}  checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("earlyCheckin") }/>
              </div> */}
            </div>
          )}

          {props.historyData.status == "Accepted" && (
            <div className="item-accepted mt-3">
              <span>Accepted.</span>
            </div>
          )}

          {props.historyData.status == "Rejected" && (
            <div className="item-cancelled mt-3">
              <span>Rejected.</span>
            </div>
          )}

          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
          
        </div>
      )}
      {/* redirect */}

      {props.historyData.redirect === "pickup" && (
        <div className="card mb-2 relative">
           <div className="absolute top-2 right-2  item-date" style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]">Pick up</div>
          <div className="item-heading mt-2">
          {props.historyData.pickUpLocation
              ? props.historyData.pickUpLocation.charAt(0).toUpperCase() + props.historyData.pickUpLocation.slice(1)
              : ""}
            <span className="px-1 item-date"> to </span>{" "}
            {props.historyData.destination ? props.historyData.destination.charAt(0).toUpperCase() + props.historyData.destination.slice(1) : ""}
          </div>
          <div className="item-date mt-1 flex">
            {/* {dateFormat(props.historyData.dateTime, "dd mmm yy")} */}
            <div className="mr-2">pick up on</div>
            {dateFormat(props.historyData.dateTime, "dd mmm yy 'at' h:MM TT")}
          </div>
          {/* Requested Accepted Cancelled */}
          {props.historyData.status == "Requested" && (
            <>
              <div className="item-requested mt-3">
                <span>Requested.</span>
                {/* You will be notify once order is confirmed{" "} */}
              </div>
              <div className="absolute top-7 right-0 p-2 cursor-pointer" >
                <Threedot onDataUpdate={(id)=>props.onDataUpdate(id)} name='pickup' data={props.historyData} checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("pickup") } />
              </div>
            </>
          )}

          {props.historyData.status == "Accepted" && (
            <div>
              <div className="bg-[#797676] mt-2 h-[1px] w-full" />
              <div className="driver-head mt-2">Assigned Driver</div>
              <div className="flex items-center justify-between my-1">
                <div className="driver-name">
                  {props.historyData?.driverName}
                  {props.historyData?.driverMobNumber ? <span>- {props.historyData?.driverMobNumber}</span> :""}
                </div>
                {props?.historyData?.driverMobNumber ? 
                <a href={`tel:${props?.historyData?.driverMobNumber}`}>
                  <img className="w-[22px]" src={CallImg} alt="" />
                </a> : ""}
              </div>
              <div className="item-accepted mt-3">
                <span>Accepted.</span>
              </div>
            </div>
          )}

          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
        </div>
      )}
      {/* Requested Processing Completed Cancelled */}
      {props.historyData.redirect === "houseKeeping" && (
        <div className="card mb-2 relative">
          <div className="absolute top-2 right-2 item-date"style={{fontSize:"11px"}}>
          Requested on:  <span className="ml-1">  {dateFormat(
              props.historyData.time,
              "dd mmm yy 'at' h:MM TT"
            )}</span>
          </div>
          <div className="card-heading  pt-[20px]">House keeping</div>
          <div className="item-heading mt-2">
            {props.historyData.serviceName}
          </div>
          {/* <div className="item-date mt-1">
            {dateFormat(props.historyData.dateTime, "dd mmm yy 'at' h:MMtt")}
          </div> */}
         <div className="item-date mt-1">
          {props.historyData.price === 0
            ? 'Free' 
            : `Price: ${currencySymbol} ${((props.historyData.price * props.historyData.count) + ((props.historyData.price * props.historyData.gst / 100) * props.historyData.count)).toFixed(2)}${props.historyData.gst !== null ? ` (Inclusive of GST)` : ''}`}
        </div>
         {props.historyData?.serviceType != "requestable" && <div className="item-date mt-1">count: {props.historyData.count}</div>}
          {props.historyData.status == "Requested" && (
            <>
            <div className="item-requested mt-3">
              <span>Requested.</span>
              {/* You will be notify once order is confirmed */}
            </div>
             <div className="absolute top-7 right-0 p-2 cursor-pointer" >
             <Threedot onDataUpdate={(id)=>props.onDataUpdate(id)} name='houseKeeping' data={props.historyData} checkStatus={() => getRequestStatus()} checkFunction={()=> checkFunctionCard("houseKeeping") } />
           </div>
           </>
          )}

          {props.historyData.status == "Processing" && (
            <div className="item-process mt-3">
              <span>Processing.</span>
            </div>
          )}

          {props.historyData.status == "Completed" && (
            <div className="item-accepted mt-3">
              <span>Completed.</span>
            </div>
          )}

          {props.historyData.status == "Cancelled" && (
            <div className="item-cancelled mt-3">
              <span>Cancelled.</span>
            </div>
          )}
        </div>
      )}
      { (roomChangeReq && CardName == 'roomChange') && (<RequestCheckAlert heading={"The Room change request is in progress"} onClose={()=>setRoomChangeReq(false)}/> )}
        {(extendStayReq && CardName == 'extendStay') && (<RequestCheckAlert heading={"The extend stay request is in progress"} onClose={()=>setExtendStayReq(false)}/> )}
      {(earlyCHeckinStatus && CardName == 'earlyCheckin') && (<RequestCheckAlert heading={"The early check-in request is in progress"} onClose={()=>setearlyCHeckinStatus(false)}/>)}
    </div>
  );
}

export default OrderCard;
